<template>
  <div>
    <div class="das_top_cont">
      <div >
        <img class="top_star" src="../../assets/img/xingxing.png" alt="" />
      </div>
      <div class="feiji1postion">
        <img src="../../assets/img/feiji.png" alt="" /><img style="position: absolute; left: -1rem; top: 100%"
          src="../../assets/img/aboutsousuo.png" alt="" />
        <img style="position: absolute; left: -88%; top: 117%" src="../../assets/img/feiji2.png" alt="" />
      </div>
      <div class="aboutmargin">
        <div class="flex_between_box">
          <div class="about-left">
            <div class="about-biaoti">
              Perform an instant search from over 500+ million companies
              worldwide
            </div>
            <div class="about-left-texttwo aboutmargin30">
              CSI covers 100% of manufacturers and service companies. The search
              includes companies large and small
            </div>
            <h3 class="about-left-head">Our <span class="tex-xiahuaxian "> Story</span></h3>

            <div class="about-left-text aboutmargin30">
              CSI’s foundations began with a penchant for servicing and
              strengthening the abilities for middle market and multinational
              clients in Asia. Our roots are grounded with exceptional
              professionals and staff with over 100 years of experience in the
              B2B intelligence industry. It’s these roots and experiences that
              our passions in the B2B industry were born. We strive to provide
              our clients with best-in-class information and fill the void of
              global reliable information.
            </div>
          </div>
          <div class="about-left">
            <img src="../../assets/img/csi1.png" alt="" />
          </div>
        </div>
      </div>
      <div class="aboutmargin">
        <div class="flex_between_box">
          <div class="about-left">
            <img src="../../assets/img/csi2.png" alt="" />
          </div>
          <div class="about-left">
            <h3 class="about-left-head">Our <span class="tex-xiahuaxian "> Purpose</span></h3>

            <div class="about-left-text aboutmargin30">
              CSI’s foundations began with a penchant for servicing and
              strengthening the abilities for middle market and multinational
              clients in Asia. Our roots are grounded with exceptional
              professionals and staff with over 100 years of experience in the
              B2B intelligence industry. It’s these roots and experiences that
              our passions in the B2B industry were born. We strive to provide
              our clients with best-in-class information and fill the void of
              global reliable information.
            </div>
          </div>
        </div>
      </div>
      <div class="aboutmargin">
        <h3 class="about-left-head">Our <span class="tex-xiahuaxian "> Data</span></h3>
        <div class="flex_between_box">
          <div class="about-left">
            <div class="about-left-text aboutmargin30">
              CSI has built a worldwide data intelligence platform to provide
              users an instant access to B2B data. We work with our selected
              partners in various markets to source valuable public information
              including business records, websites, verified data, etc. Our
              partners include industry-leading business information providers
              located around the world.<br />
              <br />
              CSI also developed our own Data Quality Index (DQI) to apply our
              strict data governance and quality standards. We apply the latest
              technologies and methodologies to build various statistical and
              analytical models to add value for our users.
            </div>
          </div>
          <div class="about-left aboutmargin30">
            <img src="../../assets/img/位图备份.png" alt="" />
          </div>
        </div>
      </div>
      <div class="aboutmargin">
        <div class="flex_between_box">
          <div class="about-left">
            <img src="../../assets/img/csi3.png" alt="" />
          </div>
          <div class="about-left">
            <h3 class="about-left-head">Our <span class="tex-xiahuaxian ">Team</span></h3>

            <div class="about-left-text aboutmargin30">
              CSI is guided by executives that have led organizations to the top
              echelons of industry, all of which have a passion for corporate
              analytics as the driver of empowerment and security for
              international trade. Our leadership crosses the spectrum of the
              B2B industry - experts in data collection, composition,
              verification, credit appraisal/analytics and marketing at the
              highest level of industry.
            </div>
          </div>
        </div>
      </div>
      <div class="aboutmargin">
        <div  style="display: flex;  justify-content: flex-start; ">
          <div class="about-left"   >
            <div class="contact_left">
              <div class="title_blue title_blue4"> <span class="tex-xiahuaxian ">Contact Us</span></div>
              <div class="contact_txt contact_m">
                Please let us know how we can help you meet your business
                requirements.
                <div>Company Search Incorporated</div>
              </div>

              <div class="contact_title_txt flex_center_between_box1">
                <div class="bottom-left">
                  <svg t="1724293161416" class="icon margin-right16" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="5608" width="1.7142857142857142rem" height="1.7142857142857142rem">
                    <path
                      d="M658.14 423.45c-54.94 0-69.72 23.29-69.72 108.63s13.94 107.37 69.72 107.37 70.56-22.17 70.56-107.37-15.2-108.63-70.56-108.63z"
                      p-id="5609" fill="#1A2332"></path>
                    <path
                      d="M512 0.79C229.67 0.79 0.79 229.67 0.79 512S229.67 1023.21 512 1023.21 1023.21 794.33 1023.21 512v-0.14C1023.21 229.6 794.4 0.79 512.14 0.79z m-69.72 703.65a7 7 0 0 1-7 7H330.86a6.84 6.84 0 0 1-6.28-4l-108.9-239.51V705a7 7 0 0 1-7 7h-74.44a7 7 0 0 1-7-7V359.86a7 7 0 0 1 7-7h115.18a6.85 6.85 0 0 1 6.42 4.18l97.61 223.12v-220.3a7 7 0 0 1 7-7h73.91a7 7 0 0 1 7 7z m216.56 12c-116 0-163.43-53.41-163.43-184.35s47.41-184.21 163.43-184.21c97.61 0 163.43 31.38 163.43 184.21s-66.1 184.35-164.13 184.35z m225.34 0a34 34 0 1 1 0.71 0.7h-1.4z"
                      p-id="5610" fill="#1A2332"></path>
                  </svg>Co. No.
                </div>
                <div class="bottom-right">2017-000781824</div>
              </div>
              <div class="contact_title_txt flex_center_between_box1">
                <div class="bottom-left">
                  <svg t="1724293261440" class="icon margin-right16" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="5904" width="1.7142857142857142rem" height="1.7142857142857142rem">
                    <path
                      d="M749.68064 48.47104c-147.56864 0-267.71968 119.92064-267.71968 267.264 0 112.86528 73.27232 239.3856 134.71232 325.74976 48.69632 68.49024 97.28 122.54208 121.856 148.58752 2.84672 3.07712 6.9376 4.78208 11.15136 4.78208s8.30976-1.70496 11.264-4.78208c24.576-26.1632 73.15968-80.20992 121.96864-148.81792 61.44-86.35392 134.59968-212.7616 134.59968-325.51936-0.11264-147.34336-120.26368-267.264-267.83232-267.264z m0 427.008c-90.112 0-163.3792-73.27232-163.3792-163.27168s73.27232-163.27168 163.3792-163.27168 163.50208 73.27232 163.50208 163.27168c-0.00512 89.99936-73.3952 163.27168-163.50208 163.27168zM488.67328 716.8l-403.456-44.032 57.56928-198.8864a27.16672 27.16672 0 0 1 25.94304-19.56864h299.80672c13.88032 38.45632 31.96928 76.11392 51.76832 111.27296L488.67328 716.8z m-54.15424 258.72896H33.56672c-8.53504 0-16.49664-3.97824-21.61664-10.69568s-6.71232-15.58528-4.3264-23.66464l54.72768-189.33248 409.6 44.71808-37.43232 178.97472z m495.84128-331.55072l36.17792 125.04576-121.16992-13.19936c21.62176-25.71264 46.08-56.65792 70.53824-91.02336 4.66944-6.71232 9.56416-13.64992 14.45376-20.82304z m60.42112 209.1264l24.91392 86.2464c1.024 2.84672 1.59744 5.9136 1.59744 9.216a26.97216 26.97216 0 0 1-27.07968 26.96704h-472.98048L552.96 805.31968l437.82144 47.78496z"
                      p-id="5905" fill="#1A2332"></path>
                  </svg>Address
                </div>
                <div class="bottom-right">
                  2619 Hibernia Street Dallas, TX 75204, USA
                </div>
              </div>
              <div class="contact_title_txt flex_center_between_box1">
                <div class="bottom-left">
                  <svg t="1724293284560" class="icon margin-right16" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="6333" id="mx_n_1724293284560" width="1.7142857142857142rem" height="1.7142857142857142rem">
                    <path
                      d="M666.48064 677.94432s-43.30496-29.1328-90.9824 19.54816c0 0-39.26016 43.61216-82.57536-12.00128 0 0-119.69536-131.42016-156.54912-278.33344 0 0-8.94976-25.89696 24.82176-31.27296 0 0 90.97216-19.5328 101.90848-60.57472L408.81152 36.75136S392.41728-14.06976 328.8064 15.22688c0 0-108.66688 27.76064-156.28288 74.43456l-8.82688 20.03968-9.71776 78.46912s5.09952 531.06176 464.86528 828.8768c0 0 157.42976 48.41984 243.83488-110.32064l10.98752-41.04192-207.18592-187.74016z"
                      fill="#1A2332" p-id="6334"></path>
                  </svg>Phone
                </div>
                <div class="bottom-right">+1 (940) 455-2284</div>
              </div>
              <div class="contact_title_txt flex_center_between_box1">
                <div class="bottom-left">
                  <svg t="1724293310819" class="icon margin-right16" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="6506" width="1.7142857142857142rem" height="1.7142857142857142rem">
                    <path
                      d="M488.3 132.2C279.8 132.2 109 276.3 109 455c0 109 64.2 207.2 161.9 266.1v100.2c0 13 8.9 21.7 20 21.7 4.2 0 8.9-2.1 11-2.1L406 773.4c26.8 4.2 53.1 6.7 79.9 6.7 208.6 0 379.4-144.1 379.4-322.9 2.4-180.9-168.3-325-377-325zM317.2 507.3c-24.2 0.1-43.9-19.3-44.2-43.5 0-24.2 20-43.5 44.2-43.5 24.1-0.1 43.8 19.3 44.2 43.5-0.4 24.1-20.1 43.5-44.2 43.5z m195.4-4.2c-13.4 8.8-30.8 8.8-44.2 0-13.2-8.8-22.1-23.8-22.1-39.3 0-24.2 20-43.5 44.2-43.5 24.2-0.1 43.9 19.3 44.2 43.5 0 17.5-8.9 30.5-22.1 39.3z m144.1 4.2c-24.2 0.1-43.9-19.3-44.2-43.5 0-24.2 20-43.5 44.2-43.5 24.1-0.1 43.9 19.3 44.2 43.5-0.4 24.1-20.1 43.5-44.2 43.5z"
                      fill="#1A2332" p-id="6507"></path>
                    <path
                      d="M872 535.7l-2.1-2.1c-6.7 21.6-13.1 43.2-24.1 62.8-8.6 14.9-53.7 89.8-107.7 127.8-58.3 40.9-150.3 59.2-150.3 59.2-26.8 6.7-53.1 8.8-79.9 10.9 42.1 37.2 101.9 58.9 168.6 58.9 17.9 0 33.2 0 51-4.2l64.2 43.4c2.1 0 4.2 2.1 6.8 2.1 6.8 0 13.2-4.2 13.2-12.9v-63.1c62-37.1 102-98.1 102-167.9 0.4-45.2-14.9-84.4-41.7-114.9z"
                      fill="#1A2332" p-id="6508"></path>
                  </svg>General inquiries
                </div>
                <div class="bottom-right">
                  <a href="mailto:service@csibizinfo.com" class="link">service@csibizinfo.com</a>
                </div>
              </div>
              <div class="contact_title_txt flex_center_between_box1">
                <div class="bottom-left">
                  <svg t="1724293334164" class="icon margin-right16" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="6760" width="1.7142857142857142rem" height="1.7142857142857142rem">
                    <path
                      d="M216.427726 604.682889c34.035164-7.385201 67.946508-6.520507 101.731986 2.582825 33.785477 9.114588 63.99757 26.456558 90.636277 52.05968 12.812817 12.791327 23.669072 27.197432 32.54523 43.184545 8.887414 16.000416 15.669888 32.601512 20.346397 49.829895 4.688789 17.228383 7.158027 34.707476 7.397481 52.425 0.249687 17.72878-1.353834 34.706453-4.802376 50.945299-33.546024 7.385201-67.331501 5.41636-101.355409-5.9055-34.036187-11.32186-64.123436-30.030967-90.261747-56.111972-26.63973-25.591865-44.528146-55.246255-53.642734-88.964194C209.894939 671.013597 209.030245 637.672234 216.427726 604.682889L216.427726 604.682889zM807.563064 604.682889c7.40669 32.988322 6.54302 66.329684-2.582825 100.047624-9.126868 33.716916-26.764574 63.37233-52.902884 88.964194-12.824073 12.790304-27.867698 23.49818-45.130873 32.124651-17.262152 8.614192-35.514865 15.498996-54.745858 20.664645s-39.08825 8.614192-59.559491 10.343579c-20.472264 1.706875-40.567951 2.081405-60.299341 1.103124l-42.912345 0L489.429447 580.331271c-28.607548-2.958378-55.236022-10.832719-79.894631-23.63428-19.24225-9.843182-36.879955-22.145369-52.901861-36.915771s-29.723975-31.247678-41.057091-49.465598c-11.345396-18.206664-20.231787-37.905308-26.638707-59.07035s-9.614985-43.309388-9.614985-66.444295c0-31.009248 6.167466-61.027935 18.491143-90.068342 23.680329 5.9055 45.506427 14.883989 65.476247 26.946722 19.970844 12.050454 37.859259 26.696012 53.642734 43.924395 4.438079-33.467229 15.407921-64.111157 32.920784-91.922572 17.511839-27.800159 39.577391-51.058886 66.216097-69.76697 27.616988 18.708084 50.194192 42.342364 67.695798 70.882374 17.511839 28.551266 28.231995 59.810201 32.17991 93.765547 15.783475-17.228383 33.796734-32.112372 54.007031-44.675502 20.22053-12.539594 42.171472-21.768793 65.852824-27.674293 11.345396 28.049846 17.011442 57.579393 17.011442 88.599897 0 22.633486-3.084245 44.538379-9.250688 65.704444-6.157233 21.166065-15.032368 40.851407-26.627451 59.059094-11.596106 18.21792-25.273616 34.707476-41.057091 49.465598-15.783475 14.770402-33.295314 27.072589-52.538587 36.914748l0 0.740874c-13.814634 6.895037-27.992541 12.426007-42.535769 16.613376-14.543228 4.187369-29.722952 6.770194-45.506427 7.760754l0 198.603267c5.929036-20.186761 15.054881-39.508829 27.379581-57.954947 12.334933-18.46863 26.627451-35.57217 42.911322-51.320852 12.824073-12.790304 27.492144-24.12342 44.026726-33.966603 16.511046-9.831926 33.660634-17.717524 51.411927-23.624047 17.762549-5.894244 35.764552-9.592472 54.006008-11.072173C773.288446 600.256066 790.800285 601.246627 807.563064 604.682889L807.563064 604.682889z"
                      fill="#1A2332" p-id="6761"></path>
                  </svg>Service orders
                </div>
                <div class="bottom-right">
                  <a href="mailto:request@CSIbizInfo.com" class="link">request@csibizinfo.com
                  </a>
                </div>
              </div>
            </div> 
        </div>
        <div class="about-left aboutmargin30" style="width: 34%;margin-left: 6%;">
          <img src="../../assets/img/csi4.png" />
        </div>
                </div>
      
      </div>
    </div>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";

export default {
  mixins: [mixins1],
  data() {
    return {};
  },
  beforeDestroy() { },
  destroyed() { },
  mounted() { },

  methods: {},
};
</script>
<style scoped>
.das_top_cont {
  padding: 36px 80px;
  background-color: #fff;
  position: relative;
}

.about-left-head {
  font-size: 40px;
  color: #1a2332;
  line-height: 50px;
  text-align: left;
 font-family: "Arial Bold";
}

.about-left-text {
  font-size: 24px;
  color: #1a2332;
  line-height: 38px;
  text-align: left;
}

.about-left-texttwo {
  font-size: 28px;
  color: #666666;
  line-height: 37px;
  margin-bottom: 109px; 
}

.about-left {
  width: 47%;
}

.aboutmargin {
  margin-bottom: 140px;
}

.aboutmargin30 {
  margin-top: 30px;
}

.flex_center_between_box1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contact_us {
  width: 100%;
}

.contact_right img {
  width: 50.42857142857143rem;
}

.contact_txt {
  font-size: 24px;
  color: #1a2332;
  line-height: 36px;
}

.contact_m {
  margin-bottom: 30px;
}

.contact_us .link {
  color: #1290c9;
  text-decoration: underline;
}

.contact_title_txt {
  margin-bottom: 20px;
 font-family: "Arial Bold";
  font-size: 24px;
}

.title_blue {
  color: #1290c9;
  margin-bottom: 36px;
  font-size: 40px;
  color: #1290c9;
  line-height: 50px;
 font-family: "Arial Bold";
}

.bottom-left {
  width: 35%;
  font-size:24px;
  color: #1a2332;
  /* line-height: 4.285714285714286rem; */
}

.bottom-right {
  width: 65%;
  text-align: left;
 font-family: "Arial Bold";
  font-size:24px;
  color: #1a2332;
  /* line-height: 4.285714285714286rem; */
}

.margin-right16 {
  margin-right: 1.1428571428571428rem;
}

.about-biaoti {
  font-size: 60px;
  color: #1a2332;
  line-height: 72px;
  text-align: left;
 font-family: "Arial Bold";
}

.feiji1postion {
  position: absolute;
  left: 40%;
  top: 1%;
}

.tex-xiahuaxian {
  background-image: linear-gradient(to right, #E9F2FF 0, #E9F2FF 100%);
  background-size: 100% 58% !important;
  background-repeat: no-repeat;
  background-size: 0 80%;
  /* background-image: linear-gradient(to right, #000 0, #000 100%); */
  transition: background-size 0.9s cubic-bezier(0.15, 0.75, 0.4, 1),
    opacity 0.25s ease;
  background-position: left 90%;
  color: #1290c9;
   font-family: "Arial Bold";

}
.top_star{
  padding-left: 18px;
  height: 50px;
}

@media screen and (max-width: 1920px) {
  
.das_top_cont {
  padding: 27px 60px; 
}

.about-biaoti {
  font-size: 46px; 
  line-height: 54px; 
}
.about-left-texttwo {
  font-size: 21px; 
  line-height: 28px;
  margin-bottom: 80px; 
}
.aboutmargin30 {
  margin-top: 22px;
}
.about-left-head {
  font-size: 30px; 
  line-height: 38px; 
}
.about-left-text {
  font-size: 18px; 
  line-height: 40px; 
}
.aboutmargin {
  margin-bottom: 50px;
}
.title_blue { 
  margin-bottom: 27px;
  font-size: 30px; 
  line-height: 38px; 
}
.contact_txt {
  font-size: 18px; 
  line-height: 27px;
}
.contact_m {
  margin-bottom: 22px;
}
.contact_title_txt {
  margin-bottom: 15px; 
  font-size: 18px;
}
.bottom-left { 
  font-size:18px; 
}
.bottom-right { 
  font-size:18px; 
}
.top_star{
  padding-left: 14px;
    height: 38px;

}
}
@media screen and (max-width: 1439px) { 
  
.das_top_cont {
  padding: 24px 54px; 
}
.about-biaoti {
  font-size: 40px; 
  line-height: 48px; 
}
.about-left-texttwo {
  font-size: 18px; 
  line-height: 24px;
  margin-bottom: 73px; 
}
.aboutmargin30 {
  margin-top: 20px;
}
.about-left-head {
  font-size: 28px; 
  line-height: 34px; 
}
.about-left-text {
  font-size: 16px; 
  line-height: 36px; 
}
.aboutmargin {
  margin-bottom: 94px;
}
.title_blue { 
  margin-bottom: 24px;
  font-size: 26px; 
  line-height: 34px; 
}
.contact_txt {
  font-size: 16px; 
  line-height: 24px;
}
.contact_m {
  margin-bottom: 20px;
}
.contact_title_txt {
  margin-bottom: 14px; 
  font-size: 16px;
}
.bottom-left { 
  font-size:16px; 
}
.bottom-right { 
  font-size:16px; 
}
.top_star{
  padding-left: 12px;
      height: 34px;

}
}
</style>